import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';


@Component({
  standalone: true,
  imports: [RouterModule, MatListModule, MatIcon, MatCardModule],
  selector: 'equine-ui-nx-products-menu',
  templateUrl: './products-menu.component.html',
  styleUrls: ['./products-menu.component.scss']
})
export class ProductsMenuComponent implements OnInit {

  links = [
    {
      label: 'Clients',
      routerLink: ['client-admin']
    },
    {
      label: 'Plans',
      routerLink: ['plan-admin']
    },
    {
      label: 'Products',
      routerLink: ['product-admin']
    },
    {
      label: 'Product categories',
      routerLink: ['product-category-admin']
    },
    {
      label: 'GL Codes',
      routerLink: ['gl-codes-admin']
    },

  ]

  constructor() { }

  ngOnInit() {
  }



}
